var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-button',{attrs:{"variant":"outline-primary","pill":""},on:{"click":_vm.create}},[_c('span',{staticClass:"align-middle"},[_vm._v(_vm._s(_vm.title))]),_c('feather-icon',{staticClass:"ml-50",attrs:{"icon":"PlusIcon"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }